<content-loader>
  <svg:rect x="0" y="0" rx="4" ry="4" width="100" height="6" />
  <svg:rect x="15" y="10" rx="4" ry="4" width="385" height="80" />
</content-loader>
